import { isEmpty } from "lodash";
import {
  exportToExcel,
  exportToCsv,
  exportToPdf,
} from "../../Utils/exportTable";

const MyAccountFilter = ({ type, tableRef, fileName, limit, onChange }) => {
  return (
    <div _ngcontent-serverapp-c79 className="push">
      <div _ngcontent-serverapp-c79 className="download-reports">
        {isEmpty(type) && (
          <>
            <div _ngcontent-serverapp-c79 className="spacer" />
            <label _ngcontent-serverapp-c79 style={{ "padding-top": "5px" }}>
              Last:
            </label>
            <select
              value={limit}
              onChange={onChange}
              _ngcontent-serverapp-c79
              name="limit"
              id="limit"
            >
              <option _ngcontent-serverapp-c79 value={10}>
                10 Txn
              </option>
              <option _ngcontent-serverapp-c79 value={25}>
                25 Txn
              </option>
              <option _ngcontent-serverapp-c79 value={50}>
                50 Txn
              </option>
              <option _ngcontent-serverapp-c79 value={100}>
                100 Txn
              </option>
            </select>
          </>
        )}
        <button
          title="Export Excel"
          className="excel btn"
          onClick={() => exportToExcel(tableRef, fileName)}
        >
          <img src="/assets/images/transparent.gif" alt="" />
        </button>

        <button
          title="Export Pdf"
          className="pdf btn"
          onClick={() => exportToPdf(tableRef, fileName)}
        >
          <img src="/assets/images/transparent.gif" alt="" />
        </button>

        <button
          title="Export Csv"
          className="csv btn"
          onClick={() => exportToCsv(tableRef, fileName)}
        >
          <img src="/assets/images/transparent.gif" alt="" />
        </button>
        {isEmpty(type) && (
          <a
            _ngcontent-serverapp-c79
            id="refresh_loginHistory"
            className="btn_replay"
            title="Show Default"
          >
            <i
              _ngcontent-serverapp-c79
              className="fas fa-redo-alt"
              style={{ "margin-top": "9px" }}
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default MyAccountFilter;
